import script from "./ConfirmationForceReleaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationForceReleaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationForceReleaseDialog.vue?vue&type=style&index=0&id=1b31cb74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b31cb74"]])

export default __exports__